
import mobx, {observable, action, computed} from 'mobx';
import BackendFactory from '../Services/BackendFactory';

export default class Location {
  @observable id: string;
  @observable name: string;
  @observable gps_lat: float;
  @observable gps_long: float;
  
  constructor(json?: any) {
    if(json) {
      this.id = json.id;
      this.name = json.name;
      this.gps_lat = json.gps_lat;
      this.gps_long = json.gps_long;
    }
  }

  static async list() {
    const backend = await BackendFactory();
    const res = await backend.get('/available-locations');
    let locations = res.data.locations.map(l => new Location(l));
    //res.data.content = locations;
    //return res.data;
    return locations;
  }

  static async listAll() {
    const backend = await BackendFactory();
    const res = await backend.get('/locations');
    let locations = res.data.map(l => new Location(l));
    //res.data.content = locations;
    //return res.data;
    return locations;
  }

  @computed get latLng(): Object {
    return {
      lat: +this.gps_lat,
      lng: +this.gps_long
    }
  }
  
}



// WEBPACK FOOTER //
// ./src/App/Store/Location.js